/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type DevicesV2ControllerGetAvailableFiltersV2Params = {
  /**
   * UUID of the space to filter results
   */
  space?: string;
};
